module.exports = __webpack_public_path__ + "static/img/invoice-accounts-receivable-factoring-vs-financing.8b52a71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/invoice-accounts-receivable-factoring-vs-financing.jpg
// module id = 1743
// module chunks = 5